import React from 'react';
import { getApiBase } from '../apiBase';

// Licensing & insurance — backed by the real compliance agent
// (/api/owner/compliance). Add a renewal → stored server-side; the list comes
// from the agent with overdue/soon bucketing; Remove marks it done.

function daysUntil(dateStr) {
  try {
    const now = new Date(); now.setHours(0, 0, 0, 0);
    const target = new Date(dateStr); if (isNaN(target.getTime())) return null;
    target.setHours(0, 0, 0, 0);
    return Math.round((target.getTime() - now.getTime()) / 86400000);
  } catch (_) { return null; }
}
function fmtDate(dateStr) {
  try { const d = new Date(dateStr); return isNaN(d.getTime()) ? dateStr : d.toLocaleDateString(undefined, { year: 'numeric', month: 'short', day: 'numeric' }); }
  catch (_) { return dateStr; }
}

export default function LicensingPanel({ ownerId, onClose }) {
  const [items, setItems] = React.useState([]);
  const [loading, setLoading] = React.useState(true);
  const [name, setName] = React.useState('');
  const [date, setDate] = React.useState('');
  const [busy, setBusy] = React.useState(false);

  const load = React.useCallback(async () => {
    setLoading(true);
    try {
      const res = await fetch(`${getApiBase()}/api/owner/compliance?withinDays=3650`);
      const data = await res.json();
      const buckets = (data && data.buckets) || {};
      const flat = [].concat(...Object.values(buckets)).filter(Boolean);
      setItems(flat);
    } catch (_) { setItems([]); }
    setLoading(false);
  }, []);
  React.useEffect(() => { load(); }, [load]);

  const add = React.useCallback(async () => {
    const n = name.trim();
    if (!n || !date || busy) return;
    setBusy(true);
    try {
      await fetch(`${getApiBase()}/api/owner/compliance`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ type: n, dueDateISO: date }) });
      setName(''); setDate('');
      await load();
    } catch (_) {}
    setBusy(false);
  }, [name, date, busy, load]);

  const remove = React.useCallback(async (id) => {
    if (!id) return;
    try { await fetch(`${getApiBase()}/api/owner/compliance/${id}/done`, { method: 'POST' }); await load(); } catch (_) {}
  }, [load]);

  const sorted = [...items].sort((a, b) => String(a.due_date || '').localeCompare(String(b.due_date || '')));

  return (
    <div className="agent-detail" onClick={onClose}>
      <div className="agent-detail__panel" onClick={(e) => e.stopPropagation()}>
        <button type="button" className="agent-detail__close" onClick={onClose} aria-label="Close">×</button>
        <div className="agent-detail__title">Licensing &amp; insurance</div>
        <div className="agent-detail__cadence">Yearly</div>
        <p className="agent-detail__desc">Tracks every renewal date and reminds you before it lapses.</p>

        <div className="agent-detail__section">Add a renewal</div>
        <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', marginBottom: 12 }}>
          <input
            type="text" value={name} onChange={(e) => setName(e.target.value)} placeholder="License or policy name"
            style={{ flex: '1 1 140px', padding: '8px 10px', borderRadius: 8, background: 'rgba(255,255,255,0.04)', border: '1px solid rgba(255,255,255,0.08)', color: 'rgba(255,255,255,0.96)' }}
          />
          <input
            type="date" value={date} onChange={(e) => setDate(e.target.value)}
            style={{ padding: '8px 10px', borderRadius: 8, background: 'rgba(255,255,255,0.04)', border: '1px solid rgba(255,255,255,0.08)', color: 'rgba(255,255,255,0.96)' }}
          />
        </div>
        <button type="button" className="agent-detail__cta" onClick={add} disabled={!name.trim() || !date || busy}>{busy ? 'Adding…' : 'Add'}</button>

        <div className="agent-detail__section">Tracked renewals</div>
        {loading ? (
          <p className="sched-muted">Loading…</p>
        ) : sorted.length === 0 ? (
          <p className="sched-muted">Add a license or policy to start tracking renewals.</p>
        ) : (
          <ul className="sched-events">
            {sorted.map((lic) => {
              const d = daysUntil(lic.due_date);
              const when = d == null ? '' : d < 0 ? `${Math.abs(d)} days ago` : d === 0 ? 'today' : `in ${d} days`;
              return (
                <li className="sched-event" key={lic.id}>
                  <span className="sched-event__t">{lic.type}</span>
                  <span className="sched-event__m">
                    {fmtDate(lic.due_date)}{when ? ` · ${when}` : ''}{'  '}
                    <a className="sched-link" role="button" onClick={() => remove(lic.id)} style={{ cursor: 'pointer' }}>Remove</a>
                  </span>
                </li>
              );
            })}
          </ul>
        )}

        <div className="agent-detail__note">Aria reminds you before each one lapses.</div>
      </div>
    </div>
  );
}
